const variantIdString = window.theme.settings.shippingProtection ? window.theme.settings.shippingProtection.variantId : '';
const excludedVariantIDs = variantIdString ? variantIdString.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id)) : [];

console.log('excludedVariantIDs=' + excludedVariantIDs.join(', '));

function getFilteredCartTotal(cart) {
  const items = cart.items;
  const spendSaveSettings = window.theme.settings.spendAndSave;
  
  console.log('=== Starting Cart Calculation ===');
  console.log('Original cart:', {
    total_price: cart.total_price / 100,
    original_total_price: cart.original_total_price / 100,
    items_subtotal_price: cart.items_subtotal_price / 100,
    total_discount: cart.total_discount / 100
  });

  console.log('All cart items with prices:', items.map(item => ({
    title: item.title,
    variant_id: item.variant_id,
    quantity: item.quantity,
    // Individual item prices
    price: item.price / 100,
    original_price: item.original_price / 100,
    final_price: item.final_price / 100,
    // Line prices (price × quantity)
    line_price: item.line_price / 100,
    original_line_price: item.original_line_price / 100,
    final_line_price: item.final_line_price / 100,
    // Discounts
    total_discount: item.total_discount / 100,
    discounted_price: item.discounted_price / 100,
    // Compare at prices if available
    compare_at_price: item.compare_at_price ? item.compare_at_price / 100 : null,
    line_level_discount_allocations: item.line_level_discount_allocations,
    // Properties
    properties: item.properties
  })));
  
  // Filter out shipping protection
  const filteredItems = items.filter(item => {
    const isExcluded = excludedVariantIDs.includes(item.variant_id);
    if (isExcluded) {
      console.log(`Excluding item from calculation:`, {
        title: item.title,
        variant_id: item.variant_id,
        price: item.price / 100,
        original_price: item.original_price / 100,
        final_price: item.final_price / 100,
        line_price: item.line_price / 100,
        original_line_price: item.original_line_price / 100,
        final_line_price: item.final_line_price / 100
      });
    }
    return !isExcluded;
  });

  // Calculate pre-discount total using original_line_price
  let preDiscountTotal = filteredItems.reduce((sum, item) => {
    return sum + item.original_line_price;
  }, 0);

  // Track free gift quantities for UI/validation purposes
  const freeGiftQuantities = new Map();
  filteredItems.forEach(item => {
    const matchingReward = spendSaveSettings.rewardsConfig
      .filter(reward => reward.type === 'FREE GIFT')
      .find(reward => reward.giftHandle.split('|').map(h => h.trim()).includes(item.handle));

    if (matchingReward) {
      const currentQty = freeGiftQuantities.get(matchingReward.threshold) || 0;
      freeGiftQuantities.set(matchingReward.threshold, currentQty + item.quantity);
      console.log(`Found free gift in cart:`, {
        title: item.title,
        handle: item.handle,
        threshold: matchingReward.threshold,
        quantity: item.quantity,
        totalQuantityForThreshold: currentQty + item.quantity,
        original_line_price: item.original_line_price / 100,
        final_line_price: item.final_line_price / 100,
        total_discount: item.total_discount / 100
      });
    }
  });

  // Log detailed calculation information
  console.log('Cart calculation details:', {
    originalCartTotal: cart.original_total_price / 100,
    currentCartTotal: cart.total_price / 100,
    filteredItems: filteredItems.map(item => ({
      title: item.title,
      handle: item.handle,
      variant_id: item.variant_id,
      quantity: item.quantity,
      // Individual item prices
      price: item.price / 100,
      original_price: item.original_price / 100,
      final_price: item.final_price / 100,
      discounted_price: item.discounted_price / 100,
      // Line prices
      line_price: item.line_price / 100,
      original_line_price: item.original_line_price / 100,
      final_line_price: item.final_line_price / 100,
      // Discounts
      total_discount: item.total_discount / 100,
      discount: (item.original_line_price - item.final_line_price) / 100,
      line_level_discount_allocations: item.line_level_discount_allocations,
      isFreeGift: spendSaveSettings.rewardsConfig
        .filter(reward => reward.type === 'FREE GIFT')
        .some(reward => reward.giftHandle.split('|').map(h => h.trim()).includes(item.handle))
    })),
    excludedVariantIDs: excludedVariantIDs,
    freeGiftQuantities: Object.fromEntries(freeGiftQuantities),
    calculatedPreDiscountTotal: preDiscountTotal,
    actualPreDiscountTotal: preDiscountTotal / 100
  });

  console.log('=== Cart Calculation Complete ===');
  
  return { total: preDiscountTotal, freeGiftQuantities };
}

async function handleFreeGifts(cartTotal, cart) {
  console.log('=== handleFreeGifts Start ===');
  console.log('Cart Total:', cartTotal.total / 100, 'Cart:', cart);
  
  const spendSaveSettings = window.theme.settings.spendAndSave;
  console.log('Spend & Save Settings:', spendSaveSettings);
  
  if (!spendSaveSettings || !spendSaveSettings.rewardsConfig) {
    console.log('Error: No rewards config found');
    return;
  }

  // Get all free gift rewards, sorted by threshold
  const freeGiftRewards = spendSaveSettings.rewardsConfig
    .filter(reward => reward.type === 'FREE GIFT')
    .sort((a, b) => b.threshold - a.threshold);

  // First, check if we need to remove the gift selection UI
  const container = document.getElementById('free-gift-container-spend-and-save');
  const freeGiftContainer = document.getElementById('free-gift-container');
  
  if (container && freeGiftContainer) {
    const giftProducts = freeGiftContainer.querySelectorAll('.free-gift-product');
    let hasQualifiedGift = false;

    giftProducts.forEach(productDiv => {
      const threshold = parseInt(productDiv.getAttribute('data-threshold'));
      if (cartTotal.total >= threshold) {
        hasQualifiedGift = true;
      }
    });

    if (!hasQualifiedGift) {
      console.log('No gifts qualify, removing gift selection UI');
      container.innerHTML = '';
    }
  }

  // Check for gifts that need to be removed or adjusted
  const cartUpdates = {};
  let needsUpdate = false;

  cart.items.forEach(item => {
    // Check if item is a free gift
    const matchingReward = freeGiftRewards.find(reward => 
      reward.giftHandle.split('|').map(h => h.trim()).includes(item.handle)
    );

    if (matchingReward) {
      const threshold = matchingReward.threshold;
      const currentQty = cartTotal.freeGiftQuantities.get(threshold) || 0;
      
      // Remove if cart total is below threshold or if quantity > 1
      if (cartTotal.total < threshold || currentQty > 1) {
        // If multiple quantities exist, only keep one if the threshold is met
        const newQty = (cartTotal.total >= threshold && currentQty > 1) ? 1 : 0;
        cartUpdates[item.key] = newQty;
        needsUpdate = true;
      }
    }
  });

  // Update cart if needed
  if (needsUpdate) {
    console.log('Updating cart with quantity adjustments:', cartUpdates);
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: cartUpdates })
      });
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      return; // Exit early as cart will refresh
    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

  // Track existing gifts by tier
  const existingGiftsByTier = new Map();
  cart.items.forEach(item => {
    freeGiftRewards.forEach(reward => {
      const tierHandles = reward.giftHandle.split('|').map(h => h.trim());
      if (tierHandles.includes(item.handle)) {
        existingGiftsByTier.set(reward.threshold, item.handle);
      }
    });
  });

  // Find all tiers the user qualifies for
  const qualifiedTiers = freeGiftRewards.filter(reward => cartTotal.total >= reward.threshold);
  console.log('Qualified tiers:', qualifiedTiers);

  // Create array of qualified gifts, excluding tiers where user already has a gift
  const qualifiedGifts = [];
  qualifiedTiers.forEach(tier => {
    if (!existingGiftsByTier.has(tier.threshold)) {
      const giftHandles = tier.giftHandle.split('|');
      giftHandles.forEach(handle => {
        qualifiedGifts.push({
          ...tier,
          giftHandle: handle.trim()
        });
      });
    }
  });

  if (qualifiedGifts.length > 0) {
    console.log('Displaying free gift options:', qualifiedGifts);
    await displayFreeGiftSelection(qualifiedGifts);
  } else {
    console.log('No new gift options to display');
    if (container) {
      container.innerHTML = '';
    }
  }
  
  console.log('=== handleFreeGifts End ===');
}


// First, update the displayFreeGiftSelection function to use the new ID
let isDisplayingGifts = false;

async function displayFreeGiftSelection(qualifiedGifts) {
  console.log('=== displayFreeGiftSelection Start ===');
  
  // Check if already processing
  if (isDisplayingGifts) {
    console.log('Already displaying gifts, skipping');
    return;
  }

  try {
    isDisplayingGifts = true;

    const mainContainer = document.getElementById('free-gift-container-spend-and-save');
    if (!mainContainer) {
      console.log('Free gift container not found');
      return;
    }

    mainContainer.innerHTML = '';

    // Create main container
    const freeGiftContainer = document.createElement('div');
    freeGiftContainer.id = 'free-gift-container';
    freeGiftContainer.className = 'cart-drawer__content-item free-gift-container';
    freeGiftContainer.style.display = 'flex';
    freeGiftContainer.style.flexWrap = 'wrap';
    freeGiftContainer.setAttribute('data-listener-attached', 'true');

    // Add the message section
    const messageHTML = `
      <div class="free-gift-message">
        Select your <b>${qualifiedGifts[0].giftTitle}</b> worth <b style="color: #3ea36a;">$${qualifiedGifts[0].giftValue / 100}</b>
        <div class="free-gift-terms">T&C: Only one <b>${qualifiedGifts[0].giftTitle}</b> per customer</div>
      </div>
    `;
    freeGiftContainer.insertAdjacentHTML('beforeend', messageHTML);

    // Fetch and display each gift option
    for (const gift of qualifiedGifts) {
      try {
        const response = await fetch(`/products/${gift.giftHandle}.js`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const product = await response.json();
        
        const productDiv = document.createElement('div');
        productDiv.className = 'free-gift-product';
        productDiv.setAttribute('data-product-handle', gift.giftHandle);
        productDiv.setAttribute('data-threshold', gift.threshold);

        // Modified variant selection HTML
        const variantOptions = product.variants.map(variant => {
          const isOutOfStock = !variant.available;
          return `
            <option 
              value="${variant.id}" 
              ${!variant.available ? 'disabled="disabled"' : ''} 
              data-available="${variant.available}"
              style="${!variant.available ? 'color: #cccccc;' : ''}"
            >
              ${variant.title}${!variant.available ? ' - Out of Stock' : ''}
            </option>
          `;
        }).join('');

        productDiv.innerHTML = `
          <img src="${product.featured_image}" alt="${product.title}" class="free-gift-image">
          <p class="free-gift-title desktop-title">${product.title}</p>
          <p class="free-gift-title mobile-title">${gift.giftTitle}</p>
          <select class="variant-select">
            <option value="" disabled selected>SIZE</option>
            ${variantOptions}
          </select>
          <button class="add-free-gift-button disabled" disabled>Add to Cart</button>
        `;
        
        freeGiftContainer.appendChild(productDiv);
      } catch (error) {
        console.error('Error fetching/displaying gift product:', error);
      }
    }

    // Only append after all products are loaded
    mainContainer.appendChild(freeGiftContainer);
    setupGiftSelectionListeners(mainContainer);
  } finally {
    isDisplayingGifts = false;
    console.log('=== displayFreeGiftSelection End ===');
  }
}

function setupGiftSelectionListeners(container) {
  // Handle variant selection
  container.querySelectorAll('.variant-select').forEach(select => {
    select.addEventListener('change', (event) => {
      const button = event.target.closest('.free-gift-product').querySelector('.add-free-gift-button');
      const selectedOption = event.target.options[event.target.selectedIndex];
      
      console.log('Variant selected:', {
        value: event.target.value,
        available: selectedOption.getAttribute('data-available'),
        disabled: selectedOption.disabled,
      });

      if (event.target.value && selectedOption) {
        // Check both disabled attribute and data-available attribute
        const isAvailable = !selectedOption.disabled && selectedOption.getAttribute('data-available') === 'true';
        
        if (isAvailable) {
          button.classList.remove('disabled');
          button.disabled = false;
          button.textContent = 'Add to Cart';
        } else {
          button.classList.add('disabled');
          button.disabled = true;
          button.textContent = 'Out of Stock';
        }
      } else {
        button.classList.add('disabled');
        button.disabled = true;
        button.textContent = 'Select Size';
      }
    });
  });

  // Handle add to cart
  container.querySelectorAll('.add-free-gift-button').forEach(button => {
    button.addEventListener('click', async (event) => {
      const select = event.target.closest('.free-gift-product').querySelector('.variant-select');
      const variantId = select.value;
      const selectedOption = select.options[select.selectedIndex];
      
      if (!variantId || !selectedOption) return;

      // Verify availability before adding to cart
      const isAvailable = !selectedOption.disabled && selectedOption.getAttribute('data-available') === 'true';
      if (!isAvailable) {
        button.textContent = 'Out of Stock';
        button.disabled = true;
        return;
      }

      try {
        button.disabled = true;
        button.textContent = 'Adding...';

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        container.innerHTML = '';
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
      } catch (error) {
        console.error('Error adding free gift:', error);
        button.textContent = 'Error - Try Again';
        button.disabled = false;
      }
    });
  });
}


async function removeGiftsFromCart(giftHandles, cart) {
  const updates = {};
  cart.items.forEach(item => {
    if (giftHandles.includes(item.handle)) {
      updates[item.key] = 0;
    }
  });

  if (Object.keys(updates).length > 0) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      console.log('Removed unqualified gifts from cart');
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    } catch (error) {
      console.error('Error removing gifts:', error);
    }
  }
}

function updateProgressAndRewards(cartTotal) {
  console.log('Updating progress and rewards with cart total:', cartTotal);
  const spendSaveSettings = window.theme.settings.spendAndSave;
  const spendSaveBar = document.querySelector('.spend-save-bar');

  if (!spendSaveBar) return;

  if (cartTotal > 0) {
    spendSaveBar.classList.remove('spend-save-bar--no-cart');
  } else {
    spendSaveBar.classList.add('spend-save-bar--no-cart');
  }

  const progressBar = spendSaveBar.querySelector('.spend-save-bar__progress');
  const maxRewardAmount = Math.max(...spendSaveSettings.rewardsConfig.map(reward => reward.threshold));
  const progressPercentage = Math.min((cartTotal / maxRewardAmount) * 100, 100);

  if (progressBar) {
    progressBar.style.width = `${progressPercentage}%`;
  }

  updateRewardMessages(cartTotal, spendSaveSettings);
  checkSubscriptionEligibility(cartTotal, spendSaveSettings);

  if (typeof window.updatePDPRewardMessage === 'function') {
    window.updatePDPRewardMessage();
  }
}

function updateRewardMessages(cartTotal, spendSaveSettings) {
  const currentRewardElement = document.querySelector('.spend-save-bar__message--current');
  const nextRewardElement = document.querySelector('.spend-save-bar__message--next');
  let currentReward = null;
  let nextReward = null;

  // Sort rewards by threshold to ensure correct progression
  const sortedRewards = [...spendSaveSettings.rewardsConfig].sort((a, b) => a.threshold - b.threshold);

  // Find current and next rewards
  for (const reward of sortedRewards) {
    if (cartTotal >= reward.threshold) {
      currentReward = reward;
    } else if (!nextReward && cartTotal < reward.threshold) {
      nextReward = reward;
      break;
    }
  }

  // Update current reward message
  if (currentReward) {
    currentRewardElement.style.display = 'block';
    let message;
    
    if (currentReward.type === 'FREE GIFT') {
      message = `<span class="hide-on-mobile">Congratulations! </span>You've qualified for a <span style="color: ${spendSaveSettings.highlightColor}">${currentReward.giftTitle}</span>`;
    } else if (currentReward.type === 'FREE SHIPPING' || currentReward.type.includes('FREE')) {
      message = `<span class="hide-on-mobile">Congratulations! </span>You've qualified for <span style="color: ${spendSaveSettings.highlightColor}">${currentReward.type}</span>`;
    } else if (currentReward.isPercentage) {
      message = `<span class="hide-on-mobile">Congratulations! </span>You've qualified for <span style="color: ${spendSaveSettings.highlightColor}">${currentReward.type} OFF</span>`;
    } else {
      message = `<span class="hide-on-mobile">Congratulations! </span>You've qualified for <span style="color: ${spendSaveSettings.highlightColor}">${currentReward.message}</span>`;
    }
    
    currentRewardElement.innerHTML = message;
  } else {
    currentRewardElement.style.display = 'none';
  }

  // Update next reward message
  if (nextReward) {
    const remainingAmount = Math.ceil((nextReward.threshold - cartTotal) / 100); // Round up to next dollar
    let rewardMessage;
    
    if (nextReward.type === 'FREE GIFT') {
      rewardMessage = `Spend <span style="color: ${spendSaveSettings.highlightColor}">$${remainingAmount.toFixed(2)}</span> more to get a <span style="color: ${spendSaveSettings.highlightColor}">${nextReward.giftTitle}</span>`;
    } else if (nextReward.type === 'FREE SHIPPING' || nextReward.type.includes('FREE')) {
      rewardMessage = `Spend <span style="color: ${spendSaveSettings.highlightColor}">$${remainingAmount.toFixed(2)}</span> more to get <span style="color: ${spendSaveSettings.highlightColor}">${nextReward.type}</span>`;
    } else if (nextReward.isPercentage) {
      rewardMessage = `Spend <span style="color: ${spendSaveSettings.highlightColor}">$${remainingAmount.toFixed(2)}</span> more to get <span style="color: ${spendSaveSettings.highlightColor}">${nextReward.type} OFF</span>`;
    } else {
      rewardMessage = `Spend <span style="color: ${spendSaveSettings.highlightColor}">$${remainingAmount.toFixed(2)}</span> more to get <span style="color: ${spendSaveSettings.highlightColor}">${nextReward.message}</span>`;
    }
    
    nextRewardElement.innerHTML = rewardMessage;
  } else {
    nextRewardElement.innerHTML = "All Spend & Save Offers Unlocked";
  }
}

// Function to check if customer is eligible for discounts and show appropriate messaging
function checkSubscriptionEligibility(cartTotal, spendSaveSettings) {
  console.log('Checking subscription eligibility');
  const spendSaveBar = document.querySelector('.spend-save-bar');
  if (!spendSaveBar) {
    console.log('Could not find spend-save-bar element');
    return;
  }

  const subscriptionMessage = spendSaveBar.querySelector('.spend-save-subscription-message');
  if (!subscriptionMessage) {
    console.log('Could not find spend-save-subscription-message element');
    return;
  }
  
  console.log('Found subscription message element:', subscriptionMessage);
  const subscriptionText = subscriptionMessage.querySelector('.spend-save-subscription-message__text');
  const signInBtn = subscriptionMessage.querySelector('.sign-in-btn');
  const becomeMemberBtn = subscriptionMessage.querySelector('.become-member-btn');
  const subscribeBtn = subscriptionMessage.querySelector('.subscribe-btn');
  
  // Check if discount restriction is enabled
  const isRestrictionEnabled = spendSaveSettings.restrictToSubscribers;
  if (!isRestrictionEnabled) {
    // No restrictions, hide message
    subscriptionMessage.style.display = 'none';
    return;
  }

  // Check if user has qualified for any discount
  const currentReward = getCurrentReward(cartTotal, spendSaveSettings.rewardsConfig);
  if (!currentReward) {
    // No reward unlocked yet, hide message
    subscriptionMessage.style.display = 'none';
    return;
  }

  // Check customer login status
  const isLoggedIn = window.theme.customer && window.theme.customer.id;
  const isSubscribed = isLoggedIn && 
    window.theme.customer.marketingPreferences && 
    window.theme.customer.marketingPreferences.emailConsent === 'subscribed-validated';

  // Apply different messaging based on customer status
  if (!isLoggedIn) {
    // Not logged in
    subscriptionText.textContent = "Sign in and Subscribe to access your discount";
    signInBtn.style.display = 'inline-block';
    becomeMemberBtn.style.display = 'inline-block';
    subscribeBtn.style.display = 'none';
    subscriptionMessage.style.display = 'block';
    
    // Add restriction class to the bar to indicate discounts aren't applied
    spendSaveBar.classList.add('spend-save-bar--restricted');
  } else if (!isSubscribed) {
    // Logged in but not subscribed
    subscriptionText.textContent = "Spend & Save offer exclusive to mailing list subscribers";
    signInBtn.style.display = 'none';
    becomeMemberBtn.style.display = 'none';
    subscribeBtn.style.display = 'inline-block';
    subscriptionMessage.style.display = 'block';
    
    // Add restriction class
    spendSaveBar.classList.add('spend-save-bar--restricted');
  } else {
    // Logged in and subscribed, customer is eligible
    subscriptionMessage.style.display = 'none';
    spendSaveBar.classList.remove('spend-save-bar--restricted');
  }
}

// Helper function to get current reward based on cart total
function getCurrentReward(cartTotal, rewardsConfig) {
  const sortedRewards = [...rewardsConfig].sort((a, b) => a.threshold - b.threshold);
  let currentReward = null;
  
  for (const reward of sortedRewards) {
    if (cartTotal >= reward.threshold) {
      currentReward = reward;
    } else {
      break;
    }
  }
  
  return currentReward;
}

// Add debounce utility function
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Debounced cart update handler
const handleCartUpdate = debounce(async () => {
  console.log("Debounced cart update handler executing");
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    console.log('Cart data fetched:', cart);
    
    const cartData = getFilteredCartTotal(cart);
    
    // Calculate total value of free gifts
    let freeGiftValues = 0;
    cart.items.forEach(item => {
      const matchingReward = window.theme.settings.spendAndSave.rewardsConfig
        .filter(reward => reward.type === 'FREE GIFT')
        .find(reward => reward.giftHandle.split('|').map(h => h.trim()).includes(item.handle));
      
      if (matchingReward) {
        freeGiftValues += matchingReward.giftValue * item.quantity;
      }
    });

    updateProgressAndRewards(cartData.total);
    handleFreeGifts(cartData, cart);
    //await updateSavingsMessage(cart, freeGiftValues);
  } catch (error) {
    console.error('Error in debounced cart update handler:', error);
  }
}, 300); // 300ms debounce delay

// Update event listeners to use debounced handler
document.addEventListener('on:cart:after-merge', () => {
  console.log("Cart after-merge event triggered - debounced handler will execute");
  handleCartUpdate();
});

// Update DOMContentLoaded event to use the same handler for consistency
document.addEventListener('DOMContentLoaded', () => {
  console.log("DOMContentLoaded event triggered - executing cart update");
  handleCartUpdate();
  
  // Add event listener for subscribe button
  const subscribeBtn = document.querySelector('.spend-save-subscription-message .subscribe-btn');
  
  if (subscribeBtn) {
    subscribeBtn.addEventListener('click', function() {
      // Open subscription modal or form
      // This will depend on your theme's subscription implementation
      if (typeof window.openSubscriptionModal === 'function') {
        window.openSubscriptionModal();
      } else {
        // Fallback - you may need to adjust this based on your theme
        const newsletterForm = document.querySelector('form[action^="/contact#newsletter"]');
        if (newsletterForm) {
          newsletterForm.scrollIntoView({ behavior: 'smooth' });
        } else {
          // If no specific form exists, redirect to a page with subscription option
          window.location.href = '/pages/newsletter-signup';
        }
      }
    });
  }
});

window.updatePDPRewardMessage = function() {
  console.log('=== Starting updatePDPRewardMessage ===');
  
  const rewardMessageElements = document.querySelectorAll('.pdp-reward-message');

  if (rewardMessageElements.length > 0) {
    const productDataElement = document.getElementById('product-data');
    if (!productDataElement) {
      console.error('Product data element not found');
      return;
    }

    try {
      const productData = JSON.parse(productDataElement.textContent);
      const productPrice = productData.price * 100; // Convert price to cents
      const spendSaveSettings = window.theme.settings.spendAndSave;

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartData = getFilteredCartTotal(cart);
          const potentialTotal = cartData.total + productPrice;
          
          console.log('Calculation:', {
            currentCartTotal: cartData.total,
            productPrice: productPrice,
            potentialTotal: potentialTotal
          });

          // Sort rewards by threshold to ensure correct progression
          const sortedRewards = [...spendSaveSettings.rewardsConfig].sort((a, b) => b.threshold - a.threshold);
          let newRewards = [];
          let moneyOffDiscountFound = false;

          // Check each reward tier from highest to lowest
          sortedRewards.forEach(reward => {
            console.log('Checking reward:', {
              type: reward.type,
              threshold: reward.threshold,
              message: reward.message,
              currentTotal: cartData.total,
              wouldQualify: potentialTotal >= reward.threshold,
              alreadyQualifies: cartData.total >= reward.threshold
            });

            if (cartData.total < reward.threshold && potentialTotal >= reward.threshold) {
              // Check if it's a money-off or percentage discount type
              if (!isNaN(reward.type) || reward.isPercentage) {
                if (!moneyOffDiscountFound) {
                  newRewards.push(reward);
                  moneyOffDiscountFound = true;
                  console.log('Added discount reward:', reward);
                }
              } else {
                // Add all non-money-off rewards (FREE GIFT and FREE SHIPPING)
                newRewards.push(reward);
                console.log('Added non-money reward:', reward);
              }
            }
          });

          console.log('New rewards to show:', newRewards);

          if (newRewards.length > 0) {
            // Format the rewards message
            let rewardMessage = "Add this product to get ";
            
            const rewardTexts = newRewards.map(reward => {
              if (reward.type === 'FREE GIFT') {
                return `a <span style="color: ${spendSaveSettings.pdpHighlightColor}">${reward.giftTitle}</span>`;
              } else if (reward.type === 'FREE SHIPPING' || reward.type.includes('FREE')) {
                return `<span style="color: ${spendSaveSettings.pdpHighlightColor}">${reward.type}</span>`;
              } else if (reward.isPercentage) {
                return `<span style="color: ${spendSaveSettings.pdpHighlightColor}">${reward.type} OFF</span>`;
              } else {
                return `<span style="color: ${spendSaveSettings.pdpHighlightColor}">${reward.message}</span>`;
              }
            });

            // Join with proper conjunctions
            if (rewardTexts.length === 1) {
              rewardMessage += rewardTexts[0];
            } else if (rewardTexts.length === 2) {
              rewardMessage += `${rewardTexts[0]} and ${rewardTexts[1]}`;
            } else {
              rewardMessage += rewardTexts.slice(0, -1).join(', ') + ', and ' + rewardTexts[rewardTexts.length - 1];
            }

            console.log('Generated message:', rewardMessage);

            rewardMessageElements.forEach(element => {
              element.innerHTML = rewardMessage;
              element.classList.add('show');
              element.style.visibility = 'visible';
              element.style.position = 'static';
            });
          } else {
            console.log('No new rewards to show, hiding elements');
            rewardMessageElements.forEach(element => {
              element.classList.remove('show');
              element.style.visibility = 'hidden';
              element.style.position = 'absolute';
            });
          }
        })
        .catch(error => {
          console.error('Error:', error);
        });
    } catch (error) {
      console.error('Error parsing product data:', error);
    }
  }
};